var ClientsAddresses = $.extend(false, BaseModule ,{

    api_route : 'clients-addresses',

    data : {
        module          : 'clients-addresses',
        page            : 1,
        limit           : 42,
        order_by        : 'id:desc',
        view            : 'grid',
        pagination      : true
    },

    init:function(){
        var module_name = this.data.module,  module = this;
    }
});

$(document).ready(function(){
    "use strict";
    ClientsAddresses.init();
});